
<script>
export default {
  name: 'RexInput',
  props: {
    name: {
      type: String,
      default: () => null,
      required: true
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    getter: {
      type: String,
      default: () => 'getField'
    },
    setter: {
      type: String,
      default: () => 'setField'
    },
    value: {
      type: String,
      default: () => null
    },
    type: {
      type: String,
      default: () => null
    },
    label: {
      type: String,
      default: () => null
    },
    placeholder: {
      type: String,
      default: () => null
    },
    minHeight: {
      type: Number,
      default: () => null
    },
    validate: {
      type: [String, Object],
      default: () => null
    },
    hasBackendValidation: {
      type: Boolean,
      default: () => false
    },
    isUppercase: {
      type: Boolean,
      default: () => false
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    },
    isLoading: {
      type: Boolean,
      default: () => false
    },
    isAutosize: {
      type: Boolean,
      default: () => false
    }
  },
  inject: ['$validator'],
  computed: {
    valueModel: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getter}`](this.target)
      },
      set(value) {
        let data = this.isUppercase ? value.toUpperCase() : value

        data = this.type === 'number' ? Number(data) : data

        this.$store.commit(`${this.storeModule}/${this.setter}`, {
          target: this.target,
          value: data
        })

        if (this.error !== null && this.hasBackendValidation) {
          const target = this.target.split('.')
          const err = this.$store.getters[`${this.storeModule}/${this.getter}`](`${target[0]}Errors`)
          const currentFieldErrorIndex = err.map(x => x.source).indexOf(this.name)

          err.splice(currentFieldErrorIndex, 1)

          this.$store.commit(`${this.storeModule}/${this.setter}`, err)
        }

        this.$emit('change', {
          element: this.$vnode.elm,
          event: data
        })
      }
    },
    error() {
      let error = null

      if (this.hasBackendValidation) {
        const target = this.target.split('.')
        const err = this.$store.getters[`${this.storeModule}/${this.getter}`](`${target[0]}Errors`)
          .find(item => item.source === this.name)

        error = err ? err.detail : null
      }

      return error
    }
  },
  mounted() {
    if (this.type === 'textarea' && this.isAutosize) {
      this.$refs.input.$refs.textarea.style.minHeight = `${this.minHeight}px`

      this.setAutoSize()
    }
  },
  methods: {
    setAutoSize() {
      if (this.isAutosize) {
        const textarea = this.$refs.input.$refs.textarea

        textarea.style.height = textarea.scrollHeight > this.minHeight
          ? `${textarea.scrollHeight}px`
          : `${this.minHeight}px`
      }
    }
  }
}
</script>

<template>
  <b-field
    custom-class="rex-label"
    :label="label"
    :type="{'is-danger': errors.has(name) || error}"
    :message="errors.first(name) || error"
  >
    <b-input
      v-if="value"
      ref="input"
      custom-class="rex-input2"
      :value="value"
      :name="name"
      :type="type"
      :placeholder="placeholder"
      :disabled="isDisabled"
      :loading="isLoading"
      @input="setAutoSize"
    />
    <b-input
      v-else
      ref="input"
      v-model="valueModel"
      v-validate="validate"
      custom-class="rex-input2"
      :name="name"
      :type="type"
      :placeholder="placeholder"
      :disabled="isDisabled"
      :loading="isLoading"
      @input="setAutoSize"
    />
  </b-field>
</template>